module.exports = __webpack_public_path__ + "img/baby-ricks.9fee142f.png";